import { DynamicStructureType } from "../types";

const dynamicStructure: DynamicStructureType = {
  buttons: {
    LocationCard_StoreHoursChevronButton: {
      states: {
        selected: {
          media: `LocationCard_StoreHoursChevronButtonMedia_selected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
        unselected: {
          media: `LocationCard_StoreHoursChevronButtonMedia_unselected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
      },
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
    },
    LocationCard_PickupHoursChevronButton: {
      states: {
        selected: {
          media: `LocationCard_PickupHoursChevronButtonMedia_selected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
        unselected: {
          media: `LocationCard_PickupHoursChevronButtonMedia_unselected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
      },
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
    },
    LocationCard_DeliveryHoursChevronButton: {
      states: {
        selected: {
          media: `LocationCard_DeliveryHoursChevronButtonMedia_selected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
        unselected: {
          media: `LocationCard_DeliveryHoursChevronButtonMedia_unselected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
      },
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
    },
    LocationCard_SeeAllRestaurantsChevronButton: {
      states: {
        unselected: {
          media: `LocationCard_SeeAllRestaurantsChevronButtonMedia_unselected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
      },
      frame: {
        width: {
          resize: `fixed`,
          max: 16,
        },
        height: {
          resize: `fixed`,
          max: 16,
        },
      },
    },
    LocationCard_MarketplaceIconButton: {
      states: {
        unselected: {
          media: `LocationCard_MarketplaceIconButtonMedia_unselected`,
          styles: {
            fillColor: `#ffffff`,
          },
        },
      },
      frame: {
        width: {
          resize: `fixed`,
          min: 48,
        },
        height: {
          resize: `fixed`,
          min: 48,
        },
      },
    },
    LocationCard_ScheduleForLaterButton: {
      states: {
        unselected: {
          label: `LocationCard_ScheduleForLaterButtonLabel_unselected`,
          styles: {
            cornerRadius: 2,
            fillColor: `#ffffff`,
            stroke: {
              color: `#e0e0e0`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        selected: {
          label: `LocationCard_ScheduleForLaterButtonLabel_selected`,
          styles: {
            cornerRadius: 2,
            fillColor: `#CCCCCC`,
            stroke: {
              color: `#e0e0e0`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        hover: {
          label: `LocationCard_ScheduleForLaterButtonLabel_hover`,
          styles: {
            cornerRadius: 2,
            fillColor: `#F5F5F5`,
            stroke: {
              color: `#e0e0e0`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        disabled: {
          label: `LocationCard_ScheduleForLaterButtonLabel_disabled`,
          styles: {
            cornerRadius: 2,
            fillColor: `#e0e0e0`,
            stroke: {
              color: `#e0e0e0`,
              type: `solid`,
              weight: 1,
            },
          },
        },
      },
      frame: {
        height: {
          resize: `fixed`,
          min: 44,
        },
        width: {
          resize: `fill`,
          min: 171,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
    },
    LocationCard_OrderNowButton: {
      states: {
        unselected: {
          label: `LocationCard_OrderNowButtonLabel_unselected`,
          styles: {
            cornerRadius: 2,
            fillColor: `#feed01`,
            stroke: {
              color: `#c2b415`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        selected: {
          label: `LocationCard_OrderNowButtonLabel_selected`,
          styles: {
            cornerRadius: 2,
            fillColor: `#C2B416`,
            stroke: {
              color: `#C2B416`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        hover: {
          label: `LocationCard_OrderNowButtonLabel_hover`,
          styles: {
            cornerRadius: 2,
            fillColor: `#FFF794`,
            stroke: {
              color: `#C2B416`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        disabled: {
          label: `LocationCard_OrderNowButtonLabel_disabled`,
          styles: {
            cornerRadius: 2,
            fillColor: `#e0e0e0`,
            stroke: {
              color: `#e0e0e0`,
              type: `solid`,
              weight: 1,
            },
          },
        },
      },
      frame: {
        height: {
          resize: `fixed`,
          min: 44,
        },
        width: {
          resize: `fill`,
          min: 108,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
    },
    LocationCard_PreorderButton: {
      states: {
        unselected: {
          label: `LocationCard_PreorderButtonLabel_unselected`,
          styles: {
            cornerRadius: 2,
            fillColor: `#feed01`,
            stroke: {
              color: `#C2B416`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        selected: {
          label: `LocationCard_PreorderButtonLabel_selected`,
          styles: {
            cornerRadius: 2,
            fillColor: `#C2B416`,
            stroke: {
              color: `#C2B416`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        hover: {
          label: `LocationCard_PreorderButtonLabel_hover`,
          styles: {
            cornerRadius: 2,
            fillColor: `#FFF794`,
            stroke: {
              color: `#C2B416`,
              type: `solid`,
              weight: 1,
            },
          },
        },
        disabled: {
          label: `LocationCard_PreorderButtonLabel_disabled`,
          styles: {
            cornerRadius: 2,
            fillColor: `#e0e0e0`,
            stroke: {
              color: `#e0e0e0`,
              type: `solid`,
              weight: 1,
            },
          },
        },
      },
      frame: {
        height: {
          resize: `fixed`,
          min: 44,
        },
        width: {
          resize: `fill`,
          min: 94,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
    },
  },
  collectionViews: {
    LocationCard_StoreHoursCollectionView: {
      spacing: {
        vertical: 30,
        horizontal: 8,
      },
      frame: {
        height: {
          resize: `hug`,
          min: 22,
        },
        width: {
          resize: `fixed`,
          min: 400,
        },
      },
      emptyView: `LocationCard_StoreHoursCollectionViewEmpty`,
      direction: `vertical`,
      sections: {
        cell: {
          width: {
            min: 112,
          },
        },
      },
    },
    LocationCard_PickupHoursCollectionView: {
      spacing: {
        vertical: 30,
        horizontal: 8,
      },
      frame: {
        height: {
          resize: `hug`,
          min: 22,
        },
        width: {
          resize: `fixed`,
          min: 400,
        },
      },
      emptyView: `LocationCard_PickupHoursCollectionViewEmpty`,
      direction: `vertical`,
      sections: {
        cell: {
          width: {
            min: 112,
          },
        },
      },
    },
    LocationCard_DeliveryHoursCollectionView: {
      spacing: {
        vertical: 30,
        horizontal: 8,
      },
      frame: {
        height: {
          resize: `hug`,
          min: 22,
        },
        width: {
          resize: `fixed`,
          min: 400,
        },
      },
      emptyView: `LocationCard_DeliveryHoursCollectionViewEmpty`,
      direction: `vertical`,
      sections: {
        cell: {
          width: {
            min: 112,
          },
        },
      },
    },
    LocationCard_MarketplaceIconsCollectionView: {
      spacing: {
        horizontal: 30,
        vertical: 8,
      },
      frame: {
        width: {
          resize: `fixed`,
          min: 400,
        },
        height: {
          resize: `hug`,
          min: 48,
        },
      },
      emptyView: `LocationCard_MarketplaceIconsCollectionViewEmpty`,
      direction: `horizontal`,
      sections: {
        cell: {
          width: {
            min: 48,
          },
        },
      },
    },
  },
  inputs: {},
  labels: {
    LocationCard_LocationLabel: {
      string: `\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#3d3d3d`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 400,
        size: 26,
        lineHeight: 32,
      },
    },
    LocationCard_DistanceLabel: {
      string: `\\() miles away `,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        size: 14,
        letterSpacing: 0.14,
        lineHeight: 16.40625,
      },
    },
    LocationCard_SeparatorLabel: {
      string: `·`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        size: 14,
        letterSpacing: 0.14,
        lineHeight: 16.40625,
      },
    },
    LocationCard_TimeLabel: {
      string: `\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        size: 14,
        letterSpacing: 0.16,
        lineHeight: 22,
      },
    },
    LocationCard_AddressLabel: {
      string: `\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        size: 16,
        letterSpacing: 0.16,
        lineHeight: 22,
      },
    },
    LocationCard_PhoneLabel: {
      string: `\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        size: 16,
        letterSpacing: 0.16,
        lineHeight: 22,
      },
    },
    LocationCard_StoreHoursLabel: {
      string: `Store Hours`,
      alignment: `left`,
      styles: {
        fillColor: `#3d3d3d`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        lineHeight: 24,
        size: 20,
      },
    },
    LocationCard_StoreOpenNowLabel: {
      string: `Open now\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        letterSpacing: 0.16,
        lineHeight: 22,
        size: 16,
      },
    },
    LocationCard_DayLabel: {
      string: `\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        size: 16,
        letterSpacing: 0.16,
        lineHeight: 22,
      },
    },
    LocationCard_PickupHoursLabel: {
      string: `Pickup Hours`,
      alignment: `left`,
      styles: {
        fillColor: `#3d3d3d`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        lineHeight: 24,
        size: 20,
      },
    },
    LocationCard_PickupOpenNowLabel: {
      string: `Open now\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        letterSpacing: 0.16,
        lineHeight: 22,
        size: 16,
      },
    },
    LocationCard_DeliveryHoursLabel: {
      string: `Delivery hours`,
      alignment: `left`,
      styles: {
        fillColor: `#3d3d3d`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        lineHeight: 24,
        size: 20,
      },
    },
    LocationCard_DeliveryOpenNowLabel: {
      string: `Open now\\()`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 600,
        letterSpacing: 0.16,
        lineHeight: 22,
        size: 16,
      },
    },
    LocationCard_SeeAllRestaurantsLabel: {
      string: `See all \\() restaurants at this location`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        size: 16,
        fontWeight: 600,
        textDecoration: `underline`,
        letterSpacing: 0.16,
        lineHeight: 22,
      },
    },
    LocationCard_ScheduleForLaterButtonLabel_unselected: {
      string: `SCHEDULE FOR LATER`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
      },
    },
    LocationCard_ScheduleForLaterButtonLabel_selected: {
      string: `SCHEDULE FOR LATER`,
      alignment: `left`,
      styles: {
        fillColor: `#3D3D3D`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
      },
    },
    LocationCard_ScheduleForLaterButtonLabel_hover: {
      string: `SCHEDULE FOR LATER`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_ScheduleForLaterButtonLabel_disabled: {
      string: `SCHEDULE FOR LATER`,
      alignment: `left`,
      styles: {
        fillColor: `#666666`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_OrderNowButtonLabel_unselected: {
      string: `Order now`,
      alignment: `left`,
      styles: {
        fillColor: `#3d3d3d`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_OrderNowButtonLabel_selected: {
      string: `Order now`,
      alignment: `left`,
      styles: {
        fillColor: `#4F4608`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_OrderNowButtonLabel_hover: {
      string: `Order Now`,
      alignment: `left`,
      styles: {
        fillColor: `#81741C`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_OrderNowButtonLabel_disabled: {
      string: `CLOSED`,
      alignment: `left`,
      styles: {
        fillColor: `#7a7a7a`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0.56,
        lineHeight: 16.40625,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_PreorderButtonLabel_unselected: {
      string: `Preorder`,
      alignment: `left`,
      styles: {
        fillColor: `#3D3D3D`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_PreorderButtonLabel_selected: {
      string: `Preorder`,
      alignment: `left`,
      styles: {
        fillColor: `#4F4608`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_PreorderButtonLabel_hover: {
      string: `Preorder`,
      alignment: `left`,
      styles: {
        fillColor: `#81741C`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: 18,
        size: 14,
        textCase: `UPPER`,
      },
    },
    LocationCard_PreorderButtonLabel_disabled: {
      string: `CLOSED`,
      alignment: `left`,
      styles: {
        fillColor: `#7A7A7A`,
        fontFamily: `'Open Sans', sans-serif`,
        fontPostScriptName: `'Open Sans', sans-serif`,
        fontWeight: 700,
        letterSpacing: 0.56,
        lineHeight: 16.40625,
        size: 14,
        textCase: `UPPER`,
      },
    },
  },
  linearLayouts: {
    LocationCardLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `fill`,
      },
      alignment: {},
      spacing: 10,
      frame: {},
      children: [`LocationCard_Wrapper`],
    },
    LocationCard_WrapperLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fixed`,
        height: `hug`,
      },
      alignment: {},
      spacing: 24,
      frame: {
        height: {
          resize: `hug`,
          min: 607,
        },
        width: {
          resize: `fixed`,
          min: 480,
        },
        padding: {
          top: 24,
          right: 24,
          bottom: 24,
          left: 24,
        },
      },
      children: [
        `LocationCard_TitleWrapper`,
        `LocationCard_PhoneAddressWrapper`,
        `LocationCard_Seperator`,
        `LocationCard_StoreHours`,
        `LocationCard_PickupHours`,
        `LocationCard_DeliveryHours`,
        `LocationCard_Seperator`,
        `LocationCard_SeeAllRestaurantsWrapper`,
        `LocationCard_MarketplaceIconsWrapper`,
        `LocationCard_FooterButtons`,
      ],
    },
    LocationCard_TitleWrapperLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {},
      spacing: 4,
      frame: {
        height: {
          resize: `hug`,
          min: 56,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      children: [
        `LocationCard_LocationWrapper`,
        `LocationCard_DistanceWrapper`,
      ],
    },
    LocationCard_LocationWrapperLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 10,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 33,
        },
      },
      children: [`LocationCard_LocationLabel`],
    },
    LocationCard_DistanceWrapperLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 4,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 19,
        },
      },
      children: [
        `LocationCard_DistanceLabel`,
        `LocationCard_SeparatorLabel`,
        `LocationCard_TimeLabel`,
      ],
    },
    LocationCard_PhoneAddressWrapperLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {},
      spacing: 12,
      frame: {
        height: {
          resize: `hug`,
          min: 56,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      children: [`LocationCard_AddressWrapper`, `LocationCard_PhoneWrapper`],
    },
    LocationCard_AddressWrapperLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      children: [`LocationCard_AddressIcon`, `LocationCard_AddressLabel`],
    },
    LocationCard_PhoneWrapperLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      children: [`LocationCard_PhoneIcon`, `LocationCard_PhoneLabel`],
    },
    LocationCard_StoreHoursLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {},
      spacing: 8,
      frame: {
        height: {
          resize: `hug`,
          min: 84,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      children: [
        `LocationCard_StoreHoursLabel`,
        `LocationCard_StoreHoursHeaderWrapper`,
        `LocationCard_StoreHoursCollectionView`,
      ],
    },
    LocationCard_StoreHoursHeaderWrapperLayout: {
      direction: `horizontal`,
      distribution: `equalSpacing`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      children: [
        `LocationCard_StoreOpenNowLabel`,
        `LocationCard_StoreHoursChevronButton`,
      ],
    },
    LocationCard_StoreHoursCollectionViewEmptyLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      children: [`LocationCard_EmptyView`],
    },
    LocationCard_EmptyViewLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fixed`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      frame: {
        height: {
          resize: `fixed`,
          min: 1,
        },
        width: {
          resize: `fixed`,
          min: 1,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      children: [],
    },
    LocationCard_PickupHoursLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {},
      spacing: 8,
      frame: {
        height: {
          resize: `hug`,
          min: 84,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      children: [
        `LocationCard_PickupHoursLabel`,
        `LocationCard_PickupHoursHeaderWrapper`,
        `LocationCard_PickupHoursCollectionView`,
      ],
    },
    LocationCard_PickupHoursHeaderWrapperLayout: {
      direction: `horizontal`,
      distribution: `equalSpacing`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      children: [
        `LocationCard_PickupOpenNowLabel`,
        `LocationCard_PickupHoursChevronButton`,
      ],
    },
    LocationCard_PickupHoursCollectionViewEmptyLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      children: [`LocationCard_EmptyView`],
    },
    LocationCard_DeliveryHoursLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {},
      spacing: 8,
      frame: {
        height: {
          resize: `hug`,
          min: 84,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      children: [
        `LocationCard_DeliveryHoursLabel`,
        `LocationCard_DeliveryHoursHeaderWrapper`,
        `LocationCard_DeliveryHoursCollectionView`,
      ],
    },
    LocationCard_DeliveryHoursHeaderWrapperLayout: {
      direction: `horizontal`,
      distribution: `equalSpacing`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      children: [
        `LocationCard_DeliveryOpenNowLabel`,
        `LocationCard_DeliveryHoursChevronButton`,
      ],
    },
    LocationCard_DeliveryHoursCollectionViewEmptyLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      children: [`LocationCard_EmptyView`],
    },
    LocationCard_SeeAllRestaurantsWrapperLayout: {
      direction: `horizontal`,
      distribution: `equalSpacing`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      children: [
        `LocationCard_SeeAllRestaurantsLabel`,
        `LocationCard_SeeAllRestaurantsChevronButton`,
      ],
    },
    LocationCard_MarketplaceIconsWrapperLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `hug`,
      },
      alignment: {
        vertical: `center`,
      },
      spacing: 12,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 21,
        },
      },
      children: [`LocationCard_MarketplaceIconsCollectionView`],
    },
    LocationCard_MarketplaceIconsCollectionViewEmptyLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      children: [`LocationCard_EmptyView`],
    },
    LocationCard_FooterButtonsLayout: {
      direction: `horizontal`,
      distribution: `fillProportionately`,
      resize: {
        width: `fill`,
        height: `fixed`,
      },
      alignment: {},
      spacing: 8,
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `fixed`,
          min: 44,
        },
      },
      children: [
        `LocationCard_ScheduleForLaterButton`,
        `LocationCard_OrderNowButton`,
        `LocationCard_PreorderButton`,
      ],
    },
    LocationCard_ScheduleForLaterButtonLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      children: [`label`],
    },
    LocationCard_OrderNowButtonLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      children: [`label`],
    },
    LocationCard_PreorderButtonLayout: {
      direction: `vertical`,
      distribution: `fillProportionately`,
      resize: {
        width: `hug`,
        height: `fixed`,
      },
      alignment: {
        horizontal: `center`,
        vertical: `center`,
      },
      spacing: 10,
      children: [`label`],
    },
  },
  views: {
    LocationCard: {
      frame: {},
      states: {
        unselected: {
          boxShadow: {
            color: `#00000019`,
            offset: {
              x: 0,
              y: 0,
            },
            radius: 12,
          },
          fillColor: `#ffffff`,
        },
      },
      linearLayout: `LocationCardLayout`,
      resize: {
        width: `fill`,
        height: `fill`,
      },
    },
    LocationCard_Wrapper: {
      frame: {
        height: {
          resize: `hug`,
          min: 607,
        },
        width: {
          resize: `fill`,
          min: 480,
        },
        padding: {
          top: 24,
          right: 24,
          bottom: 24,
          left: 24,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_WrapperLayout`,
    },
    LocationCard_TitleWrapper: {
      frame: {
        height: {
          resize: `hug`,
          min: 56,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_TitleWrapperLayout`,
    },
    LocationCard_LocationWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 33,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_LocationWrapperLayout`,
    },
    LocationCard_DistanceWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 19,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_DistanceWrapperLayout`,
    },
    LocationCard_PhoneAddressWrapper: {
      frame: {
        height: {
          resize: `hug`,
          min: 56,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_PhoneAddressWrapperLayout`,
    },
    LocationCard_AddressWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_AddressWrapperLayout`,
    },
    LocationCard_AddressIcon: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='12' height='17' viewBox='0 0 12 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.375 15.6875C5.65625 16.125 6.3125 16.125 6.59375 15.6875C11.1562 9.125 12 8.4375 12 6C12 2.6875 9.3125 0 6 0C2.65625 0 0 2.6875 0 6C0 8.4375 0.8125 9.125 5.375 15.6875ZM6 8.5C4.59375 8.5 3.5 7.40625 3.5 6C3.5 4.625 4.59375 3.5 6 3.5C7.375 3.5 8.5 4.625 8.5 6C8.5 7.40625 7.375 8.5 6 8.5Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {
          fillColor: `#ffffff`,
        },
      },
    },
    LocationCard_PhoneWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_PhoneWrapperLayout`,
    },
    LocationCard_PhoneIcon: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.5312 11.3125L12.0312 9.8125C11.9375 9.78125 11.8438 9.75 11.7188 9.75C11.5 9.75 11.2812 9.875 11.1562 10.0312L9.59375 11.9375C7.15625 10.7812 5.21875 8.84375 4.0625 6.40625L5.96875 4.84375C6.125 4.71875 6.25 4.5 6.25 4.25C6.25 4.15625 6.21875 4.0625 6.1875 3.96875L4.6875 0.46875C4.5625 0.1875 4.28125 0 3.96875 0C3.9375 0 3.875 0.03125 3.8125 0.03125L0.5625 0.78125C0.21875 0.875 0 1.15625 0 1.5C0 9.53125 6.46875 16 14.5 16C14.8438 16 15.125 15.7812 15.2188 15.4375L15.9688 12.1875C15.9688 12.125 15.9688 12.0625 15.9688 12.0312C15.9688 11.7188 15.7812 11.4375 15.5312 11.3125Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {
          fillColor: `#ffffff`,
        },
      },
    },
    LocationCard_Seperator: {
      frame: {
        aspectRatio: {
          height: 0,
          width: 432,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `fixed`,
          min: 0,
        },
      },
      states: {
        unselected: {
          stroke: {
            color: `#cccccc`,
            type: `solid`,
            weight: 1,
          },
        },
      },
    },
    LocationCard_StoreHours: {
      frame: {
        height: {
          resize: `hug`,
          min: 84,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_StoreHoursLayout`,
    },
    LocationCard_StoreHoursHeaderWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_StoreHoursHeaderWrapperLayout`,
    },
    LocationCard_StoreHoursChevronButtonMedia_selected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 1.09375C7.21875 0.8125 6.75 0.8125 6.46875 1.09375L0.375 7.15625C0.09375 7.46875 0.09375 7.9375 0.375 8.21875L1.09375 8.9375C1.375 9.21875 1.84375 9.21875 2.15625 8.9375L7 4.125L11.8125 8.9375C12.125 9.21875 12.5938 9.21875 12.875 8.9375L13.5938 8.21875C13.875 7.9375 13.875 7.46875 13.5938 7.15625L7.5 1.09375Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_StoreHoursChevronButtonMedia_unselected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.46875 8.9375C6.75 9.21875 7.21875 9.21875 7.5 8.9375L13.5938 2.875C13.875 2.5625 13.875 2.09375 13.5938 1.8125L12.875 1.09375C12.5938 0.8125 12.125 0.8125 11.8125 1.09375L7 5.90625L2.15625 1.09375C1.84375 0.8125 1.375 0.8125 1.09375 1.09375L0.375 1.8125C0.09375 2.09375 0.09375 2.5625 0.375 2.875L6.46875 8.9375Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_StoreHoursCollectionViewEmpty: {
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_StoreHoursCollectionViewEmptyLayout`,
    },
    LocationCard_EmptyView: {
      frame: {
        height: {
          resize: `fixed`,
          min: 1,
        },
        width: {
          resize: `fixed`,
          min: 1,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_EmptyViewLayout`,
    },
    LocationCard_PickupHours: {
      frame: {
        height: {
          resize: `hug`,
          min: 84,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_PickupHoursLayout`,
    },
    LocationCard_PickupHoursHeaderWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_PickupHoursHeaderWrapperLayout`,
    },
    LocationCard_PickupHoursChevronButtonMedia_selected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 1.09375C7.21875 0.8125 6.75 0.8125 6.46875 1.09375L0.375 7.15625C0.09375 7.46875 0.09375 7.9375 0.375 8.21875L1.09375 8.9375C1.375 9.21875 1.84375 9.21875 2.15625 8.9375L7 4.125L11.8125 8.9375C12.125 9.21875 12.5938 9.21875 12.875 8.9375L13.5938 8.21875C13.875 7.9375 13.875 7.46875 13.5938 7.15625L7.5 1.09375Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_PickupHoursChevronButtonMedia_unselected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.46875 8.9375C6.75 9.21875 7.21875 9.21875 7.5 8.9375L13.5938 2.875C13.875 2.5625 13.875 2.09375 13.5938 1.8125L12.875 1.09375C12.5938 0.8125 12.125 0.8125 11.8125 1.09375L7 5.90625L2.15625 1.09375C1.84375 0.8125 1.375 0.8125 1.09375 1.09375L0.375 1.8125C0.09375 2.09375 0.09375 2.5625 0.375 2.875L6.46875 8.9375Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_PickupHoursCollectionViewEmpty: {
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_PickupHoursCollectionViewEmptyLayout`,
    },
    LocationCard_DeliveryHours: {
      frame: {
        height: {
          resize: `hug`,
          min: 84,
        },
        width: {
          resize: `fill`,
          min: 432,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_DeliveryHoursLayout`,
    },
    LocationCard_DeliveryHoursHeaderWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_DeliveryHoursHeaderWrapperLayout`,
    },
    LocationCard_DeliveryHoursChevronButtonMedia_selected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 1.09375C7.21875 0.8125 6.75 0.8125 6.46875 1.09375L0.375 7.15625C0.09375 7.46875 0.09375 7.9375 0.375 8.21875L1.09375 8.9375C1.375 9.21875 1.84375 9.21875 2.15625 8.9375L7 4.125L11.8125 8.9375C12.125 9.21875 12.5938 9.21875 12.875 8.9375L13.5938 8.21875C13.875 7.9375 13.875 7.46875 13.5938 7.15625L7.5 1.09375Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_DeliveryHoursChevronButtonMedia_unselected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.46875 8.9375C6.75 9.21875 7.21875 9.21875 7.5 8.9375L13.5938 2.875C13.875 2.5625 13.875 2.09375 13.5938 1.8125L12.875 1.09375C12.5938 0.8125 12.125 0.8125 11.8125 1.09375L7 5.90625L2.15625 1.09375C1.84375 0.8125 1.375 0.8125 1.09375 1.09375L0.375 1.8125C0.09375 2.09375 0.09375 2.5625 0.375 2.875L6.46875 8.9375Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_DeliveryHoursCollectionViewEmpty: {
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_DeliveryHoursCollectionViewEmptyLayout`,
    },
    LocationCard_SeeAllRestaurantsWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 22,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_SeeAllRestaurantsWrapperLayout`,
    },
    LocationCard_SeeAllRestaurantsChevronButtonMedia_unselected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
        height: {
          resize: `fixed`,
          min: 16,
          max: 16,
        },
      },
      media: `data:image/svg+xml,%3Csvg width='10' height='14' viewBox='0 0 10 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.90625 7.53125C9.1875 7.25 9.1875 6.78125 8.90625 6.5L2.84375 0.40625C2.53125 0.125 2.0625 0.125 1.78125 0.40625L1.0625 1.125C0.78125 1.40625 0.78125 1.875 1.0625 2.1875L5.875 7L1.0625 11.8438C0.78125 12.1562 0.78125 12.625 1.0625 12.9062L1.78125 13.625C2.0625 13.9062 2.53125 13.9062 2.84375 13.625L8.90625 7.53125Z' fill='%23666666'/%3E%3C/svg%3E%0A`,
      states: {
        unselected: {},
      },
    },
    LocationCard_MarketplaceIconsWrapper: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `hug`,
          min: 21,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_MarketplaceIconsWrapperLayout`,
    },
    LocationCard_MarketplaceIconsCollectionViewEmpty: {
      frame: {
        width: {
          resize: `hug`,
          min: 220,
        },
        height: {
          resize: `fixed`,
          min: 21,
        },
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_MarketplaceIconsCollectionViewEmptyLayout`,
    },
    LocationCard_MarketplaceIconButtonMedia_unselected: {
      frame: {
        width: {
          resize: `fixed`,
          min: 48,
        },
        height: {
          resize: `fixed`,
          min: 48,
        },
      },
      states: {
        unselected: {},
      },
    },
    LocationCard_FooterButtons: {
      frame: {
        width: {
          resize: `fill`,
          min: 432,
        },
        height: {
          resize: `fixed`,
          min: 44,
        },
      },
      states: {
        unselected: {},
      },
      linearLayout: `LocationCard_FooterButtonsLayout`,
    },
  },
};

export default dynamicStructure; // as DynamicStructureNode<Structure>; TODO
